import styled from 'styled-components'
import { theme } from '../../../../styles/theme'

export const Container = styled.div`
`

export const CreatedAt = styled.div`
  display: flex;
  align-items: center;
  gap: 7.5px;

  & > p {
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.normal};
    font-size: ${theme.font.sizes.medium};
    line-height: ${theme.font.sizes.large};
    color: #42425D;
  }
`

export const OrderId = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;

  font-family: ${theme.font.inter};
  font-weight: ${theme.font.normal};
  font-size: ${theme.font.sizes.medium};
  line-height: ${theme.font.sizes.large};
  color: #42425D;

  & > div {
    width: 6px;
    height: 6px;

    border-radius: 3px;
    background: ${theme.colors.brown};
  }
`

export const Footer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  & button {
    padding: 18px 33px;

    display: flex;
    justify-content: center;
    align-items: center;

    background: ${theme.colors.red};
    box-shadow: 0px 3px 2px rgba(121, 108, 95, 0.22);
    border-radius: 8px;
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.semiBold};
    font-size: ${theme.font.sizes.large};
    line-height: ${theme.font.sizes.xlarge};
    color: ${theme.colors.mainBg};

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }
`

export const PartialWrapper = styled.div`
  width: 75%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 18px;

  & > div.alert {
    height: 60px;
    padding: 35px;

    display: flex;
    align-items: center;
    justify-content: center;

    background: ${theme.colors.lightYellow};
    border-radius: ${theme.border.mediumRadius};

    & > p {
      font-family: ${theme.font.inter};
      font-weight: ${theme.font.normal};
      font-size: ${theme.font.sizes.small};
      line-height: ${theme.font.sizes.normal};
      color: ${theme.colors.brown};
      text-align: center;
    }
  }
`
